import { Modal } from "bootstrap";
import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import {
    useForm,
} from "react-hook-form";

import { toast } from "react-toastify";

import * as b2cleadService from "../../Services/b2cleadService";

const B2CActivityPostCommentModal = forwardRef(
    (props, ref) => {

        const {
            leadDetails,
            getLeadData,
            getLeadFollowup,
        } = props;

        const {
            register,
            handleSubmit,
            reset,
            formState: { errors },
        } = useForm({
            mode: "onSubmit",
        });

        const modalRef = useRef(null);
        const bsModal = useRef(null);
        // const [activityComments, setActivityComments] = useState([]);

        // STATES
        const [submitLoader, setSubmitLoader] =
            useState(false);

        const [attachment, setAttachment] =
            useState(null);

        // CLOSE MODAL
        const handleClose = () => {

            reset();

            setAttachment(null);

            bsModal.current?.hide();

        };

        // MODAL HANDLE
        useImperativeHandle(ref, () => ({

            toggle() {

                if (!bsModal.current) {

                    bsModal.current =
                        new Modal(
                            modalRef.current
                        );

                }

                bsModal.current.show();

            },

            close() {

                handleClose();

            },

        }));

        // FILE CHANGE
        const handleFileChange = (
            e
        ) => {

            const file =
                e.target.files[0];

            if (!file) return;

            if (
                file.type.startsWith(
                    "image/"
                ) ||
                file.type ===
                "application/pdf"
            ) {

                setAttachment(file);

            } else {

                toast.error(
                    "Only image and PDF files are allowed"
                );

            }

        };

        // SUBMIT
        const onSubmit = async (
            data
        ) => {

            setSubmitLoader(true);

            try {

                const formData =
                    new FormData();

                formData.append(
                    "comment",
                    data?.comment || ""
                );

                if (attachment) {

                    formData.append(
                        "attachment",
                        attachment
                    );

                }

                const leadId =
                    leadDetails?.id;

                const res =
                    await b2cleadService.postComment(
                        leadId,
                        formData
                    );

                if (res?.data?.status === "success") {

                    toast.success(
                        res?.data?.message ||
                        "Comment posted successfully"
                    );

                    handleClose();

                    getLeadData();

                    getLeadFollowup();

                }

                else {

                    toast.error(
                        res?.data?.message ||
                        "Failed To Post Comment"
                    );

                }

            } catch (error) {

                console.log(
                    "COMMENT ERROR",
                    error
                );

                toast.error(
                    error?.response?.data
                        ?.message ||
                    "Failed To Post Comment"
                );

            } finally {

                setSubmitLoader(false);

            }

        };

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-lg modal-dialog-centered">

                    <div className="modal-content border-0 rounded-4 overflow-hidden">

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "linear-gradient(135deg,#2563eb,#1d4ed8)",
                            }}
                        >

                            <div>

                                <p className="mb-0 small opacity-75">

                                    Add followup comment

                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* COMMENT */}
                                    <div className="col-md-12">

                                        <label className="form-label fw-semibold">

                                            Comment

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <textarea
                                            className={`form-control ${errors.comment
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            rows="6"
                                            placeholder="Enter comment"
                                            {...register(
                                                "comment",
                                                {
                                                    required:
                                                        "Comment is required",
                                                }
                                            )}
                                        />

                                        {errors.comment && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .comment
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                    {/* ATTACHMENT */}
                                    <div className="col-md-12">

                                        <label className="form-label fw-semibold">

                                            Attachment

                                        </label>

                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={
                                                handleFileChange
                                            }
                                        />

                                        <small className="text-muted">

                                            Only image and PDF files allowed

                                        </small>

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={
                                        handleClose
                                    }
                                >

                                    Close

                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    disabled={
                                        submitLoader
                                    }
                                >

                                    {submitLoader
                                        ? "Posting..."
                                        : "Save"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        );

    }
);

export default B2CActivityPostCommentModal;